import { AgentInvocationStatus } from 'types/agents/QuickQuoteAgent';

/**
 * Returns the className string for styling an agent invocation status badge
 * @param status - The agent invocation status
 * @returns A className string with appropriate styling classes
 */
export const getAgentInvocationStatusClassName = (
  status: AgentInvocationStatus
): string => {
  const baseClasses = 'px-2 py-0.5 rounded-full tracking-wide capitalize';

  if (status === AgentInvocationStatus.Completed) {
    return `${baseClasses} bg-success-main/20 text-success-main`;
  }

  if (status === AgentInvocationStatus.InProgress) {
    return `${baseClasses} bg-info-main/20 text-info-main`;
  }

  if (status === AgentInvocationStatus.Failed) {
    return `${baseClasses} bg-error-main/20 text-error-main`;
  }

  // Default/unknown status
  return `${baseClasses} bg-neutral-200 text-neutral-700`;
};
